<template>
  <div class="service-unavailable d-flex flex-column align-items-center justify-content-center text-center">
    <h2 class="mb-3">We're having trouble connecting</h2>
    <p class="mb-4">The service is temporarily unavailable. Please try again in a moment.</p>
    <button type="button" class="btn btn-primary" @click="$emit('retry')">Retry</button>
  </div>
</template>

<script>
export default {
  name: "ServiceUnavailable",
};
</script>

<style scoped>
.service-unavailable {
  min-height: 100vh;
  padding: 16px;
}
</style>
